import * as React from 'react';
import '@swc/helpers';
import '@grandvisionhq/utils';
import { usePaymentsUIContext } from '../../../../../context/PaymentsUI/context.js';
import '@paypal/react-paypal-js';
import '@grandvisionhq/state';
import { GooglePay } from './GooglePay.js';
import { mapLineItemsToTransactionInfoItems } from './mappers/transaction-info-line-items.js';

const GooglePayRegularContainer = ({ onClick , onAuthorize  })=>{
    const { cartPrices , lineItems , setGooglePayToken  } = usePaymentsUIContext();
    const mappedLineItems = mapLineItemsToTransactionInfoItems(lineItems);
    return /*#__PURE__*/ React.createElement(GooglePay, {
        cartPrices: cartPrices,
        lineItems: mappedLineItems,
        setGooglePayToken: setGooglePayToken,
        onClick: onClick,
        onAuthorize: onAuthorize
    });
};

export { GooglePayRegularContainer };
//# sourceMappingURL=GooglePayRegularContainer.js.map
